<template>
  <fornitori-conti-acquisto />
</template>

<script>
import FornitoriContiAcquisto from '@/components/ask/pages/tesoreria/FornitoriContiAcquisto.vue'

export default {
  name: 'PageFornitoriContiAcquisto',

  components:{
    FornitoriContiAcquisto
  },

  data(){
    return {
    
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods:{

  },
}
</script>

<style>

</style>
